(function () {
    'use strict';

    // @ngInject
    function AccountsManagerServiceCtor(APIService, ModelFactory, $q, Routes, Enums, UsersManager, CompaniesManager, RepositoryService, _, ModelUtils, FeaturesService) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
        this.Enums = Enums;
        this.UsersManager = UsersManager;
        this.CompaniesManager = CompaniesManager;
        this.RepositoryService = RepositoryService;
        this.ModelUtils = ModelUtils;
        this.FeaturesService = FeaturesService;
        this._ = _;
        this.$q = $q;

        let company = CompaniesManager.getCurrCompany();
        this._registerCompanySuccess(company);
    }

    Services.AccountsManager = Class(Services.BaseModelManager, {
        constructor: AccountsManagerServiceCtor,

        getAvailablePricingPlans(accountId, promoCode) {
            let url = this.Routes.v2_get_available_pricing_plans_path(accountId);
            let data = {
                promo_code: promoCode,
            };
            return this.apiFetch(url, data);
        },

        getPricingPlanForAccount(accountId) {
            let url = this.Routes.v2_get_pricing_plan_for_account_path(accountId);
            return this.apiFetch(url);
        },

        createPricingPlan(accountId, pricingPlanId, promoCodeId ,paymentMethod) {
            let url = this.Routes.v2_create_pricing_plan_path(accountId);
            if (paymentMethod) {
                paymentMethod._type = this.Enums.PaymentMethodTypes.creditCard;
            }

            let promise = this.apiCreate(url, {pricing_plan_id: pricingPlanId, promo_code_id: promoCodeId, payment_method: paymentMethod});

            promise.then((res) => { this._savePaymentMethod(res); });

            return promise;
        },

        cancelPricingPlan(accountId, reasons, otherReason, extraInfo) {
            const user = this.UsersManager.getCurrUser();
            let url;
            if (user.getSubscription()) {
                url = this.Routes.v2_cancel_subscription_path(accountId);
            } else {
                url = this.Routes.v2_cancel_pricing_plan_path(accountId);
            }

            const data = {
                cancellation_reasons: reasons
            };

            if (otherReason) {
                data.other_reason = otherReason;
            }

            if (extraInfo) {
                data.extra_info = extraInfo;
            }

            return this.apiUpdate(url, data);
        },

        pausePricingPlan(accountId, reasons, otherReason, extraInfo) {
            const user = this.UsersManager.getCurrUser();
            let url;
            if (user.getSubscription()) {
                url = this.Routes.v2_pause_subscription_path(accountId);
            } else {
                url = this.Routes.v2_pause_pricing_plan_path(accountId);
            }

            const data = {
                cancellation_reasons: reasons
            };

            if (otherReason) {
                data.other_reason = otherReason;
            }

            if (extraInfo) {
                data.extra_info = extraInfo;
            }

            return this.apiUpdate(url, data);
        },


        changePaymentMethod(accountId, paymentMethod) {
            let url = this.Routes.v2_change_payment_method_for_pricing_plan_path(accountId);
            if (paymentMethod) {
                paymentMethod._type = this.Enums.PaymentMethodTypes.creditCard;
            }
            let promise = this.apiUpdate(url, {
                payment_method: paymentMethod
            });

            promise.then((res) => { this._savePaymentMethod(res); });

            return promise;
        },

        _savePaymentMethod(res) {
            this.UsersManager.getCurrUser().payment_methods = res.data.payment_methods;
            this.UsersManager.saveCurrUser();
        },

        createCompany: function createCompany(accountId, companyType, companyName) {
            let url = this.Routes.v2_create_new_company_path(accountId);
            return this.apiCreate(url, {company_type: companyType, company_name: companyName});
        },

        getCompanies: function getCompanies(accountId) {
            let url = this.Routes.v2_list_account_companies_path(accountId);
            return this.apiFetch(url).then((resp) => {
               let user = this.UsersManager.getCurrUser();
               let companiesMap = this._.groupBy(resp.data, '_id');
               user.companies.forEach((company) => {
                   let _company = companiesMap[company._id][0];
                   this.ModelUtils.extendModel(company, _company);
               });

               return user.companies;
            });
        },

        switchCompany(companyId) {
            this.RepositoryService.cacheClearAll();
            this.RepositoryService.persistentClearAll();
            let user = this.UsersManager.getCurrUser();
            // reset user's company
            user.company.offAll();
            user.company = this.ModelFactory.newCompanyModel();
            user.company._id = companyId;
            user.company_id = companyId;
            return this.UsersManager.forceFetchCurrUser().then(() => {
                // why this doesn't return a promise..
                let currCompany = this.CompaniesManager.getCurrCompany(true);
                let defer = this.$q.defer();
                currCompany.once('success', () => { defer.resolve(); });
                currCompany.once('error', () => { defer.reject(); });
                return defer.promise;
            }).then(() => {
                return this._registerCompanySuccess(user.company);
            });
        },

        deleteCompany(accountId, companyId) {
            let url = this.Routes.v2_delete_company_path(accountId, companyId);
            return this.apiDelete(url);
        },

        _registerCompanySuccess(company) {
            company.on('success', () => { this.getCompanies(company.account_id); }, this);
        },

        purchaseSubscription(planCode, couponCode, tokenId) {
            let data = {
                plan_code: planCode,
                coupon_code: couponCode,
                token_id: tokenId
            };

            let user = this.UsersManager.getCurrUser();
            let accountId = user.account_id;
            let url = this.Routes.v2_purchase_subscription_path(accountId);
            return this.apiCreate(url, data, user, true);
        },

        updateBillingInfo(tokenId) {
            const data = {
                token_id: tokenId
            };

            let accountId = this.UsersManager.getCurrUser().account_id;
            let url = this.Routes.v2_update_billing_info_path(accountId);
            return this.apiUpdate(url, data);
        }
    });
}());
